import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  timeout: 20000,
});

export const submitLead = (payload) => api.post("/leads", payload).then((r) => r.data);

export const getCallbackAvailability = (dateStr) =>
  api.get(`/callbacks/availability`, { params: { date: dateStr } }).then((r) => r.data);

export const submitCallback = (payload) => api.post("/callbacks", payload).then((r) => r.data);

export const submitFinancing = (payload) => api.post("/financing-inquiry", payload).then((r) => r.data);

export const submitAduLead = (payload) => api.post("/adu-leads", payload).then((r) => r.data);

export const getHealth = () => api.get("/health").then((r) => r.data);
